// lib/features/floatingContent/floatingContent.thunk.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFloatingContent } from "./floatingContent.service";
import { FloatingContentData } from "./floatingContent.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";
import { handleApiError } from "@/app/utils/handleApiError";

export const getFloatingContent = createAsyncThunk<
  FloatingContentData,
  void,
  RejectValueType & { state: RootState }
>(
  "floatingContent/getFloatingContent",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchFloatingContent();
      return response.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { floatingContent } = getState();
      if (floatingContent.data) return false;
      if (floatingContent.status === "loading") return false;
      return true;
    },
  },
);
